import React from "react";
import styles from './Popup.module.scss';

const Popup = ({ show = false, children, onShow, title, onClose }) => {

  return (
    <div className={[styles.PopupWrapper, (show ? styles.show : styles.hide)].join(' ')}>
      <div className={[styles.header, 'd-flex', 'align-items-center', 'justify-content-between']. join(" ")}>
        <div className={styles.title}>
          {title}
        </div>
        <div className={styles.closeIcon} onClick={onClose}>
          <i>
            <svg className={'d-flex'} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="14.25" y1="4.81066" x2="4.81066" y2="14.25" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M4.44995 4.45L14.2075 14.2075" stroke="#70789E" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </i>
        </div>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
};

export default Popup;